
const PIXEL_ID = '8638100566251155'

const BLOCKED_HOSTNAMES = [
  'chatbot.nqartificial.com'
]

export function initPixel() {
  if (typeof window === 'undefined') return
  if (BLOCKED_HOSTNAMES.some(h => window.location.hostname.includes(h))) return
  if (window.fbq) return

  !function (f, b, e, v, n, t, s) {
    if (f.fbq) return; n = f.fbq = function () {
      n.callMethod ?
      n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    };
    if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = '2.0';
    n.queue = []; t = b.createElement(e); t.async = !0;
    t.src = v; s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s)
  }(window, document, 'script',
    'https://connect.facebook.net/en_US/fbevents.js')

  window.fbq('init', PIXEL_ID)
}

function track(eventName, params) {
  if (typeof window === 'undefined') return
  if (!window.fbq) return
  window.fbq('track', eventName, params)
}

export const pixel = {

  pageView() {
    track('PageView')
  },

  viewContent(data) {
    data = data || {}
    track('ViewContent', {
      content_name: data.name || '',
      content_category: data.category || '',
      content_type: 'product',
      value: data.value || 0,
      currency: 'COP'
    })
  },

  lead(data) {
    data = data || {}
    track('Lead', {
      content_name: data.name || 'Lead NQArtificial',
      content_category: data.category || '',
      value: data.value || 0,
      currency: 'COP'
    })
  },

  initiateCheckout(data) {
    data = data || {}
    track('InitiateCheckout', {
      content_name: data.plan || 'Plan NQArtificial',
      num_items: data.items || 1,
      value: data.value || 0,
      currency: 'COP'
    })
  },

  purchase(data) {
    data = data || {}
    track('Purchase', {
      content_name: data.plan || 'Plan NQArtificial',
      value: data.value || 0,
      currency: 'COP'
    })
  },

  completeRegistration(data) {
    data = data || {}
    track('CompleteRegistration', {
      content_name: data.name || 'Registro NQArtificial',
      status: true,
      value: data.value || 0,
      currency: 'COP'
    })
  },

  identify(data) {
    if (typeof window === 'undefined') return
    if (!window.fbq) return
    data = data || {}
    window.fbq('setUserData', { em: data.em || '', fn: data.fn || '' })
  }

}
